import api from './axiosConfig'
import { Region } from './types'

const BASE_PATH='portal/'


const regionsService = {
  getRegion: async () => {
    const response = await api.get<Region>(`${BASE_PATH}regions`)
    return response.data
  },
}

export default regionsService 